import { CreateProfileComponent } from './orc-create-profile/create-profile.component';
import { SearchProfileComponent } from './orc-search-profile/search-profile.component';

export const routes = [
  {
    path: 'search-profile',
    component: SearchProfileComponent,
    data: {
      hideFooter: true,
      basicHeader: true,
      fullWidthHeader: true,
      title: 'Find your RateMyAgent profile',
    },
    children: [
      {
        path: '**',
        redirectTo: '',
      },
    ],
  },
  {
    path: 'create-profile',
    component: CreateProfileComponent,
    data: {
      hideFooter: true,
      basicHeader: true,
      title: 'Create your RateMyAgent profile',
    },
  },
];
